<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Location"
              icon="fas fa-pen-to-square">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="location">Location</label><br>
                    <input class="form-control" id="location" style="width: 100%;" ngx-google-places-autocomplete #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Latitude</label>
                    <input type="number" class="form-control" [(ngModel)]="lat" (change)="latLngChange()">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Longitude</label>
                    <input type="number" class="form-control" [(ngModel)]="lng" (change)="latLngChange()">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="geofence">Location Privacy Geo-Fence (in meters)&nbsp;<i class="fa fa-info" [ngbTooltip]="tooltipMessage"></i></label><br>
                    <input class="form-control" type="number" id="geofence" style="width: 100%;" [(ngModel)]="geofence" />
                  </div>
                </div>
                <div class="col-md-12">
                  <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [fullscreenControl]="true" [mapTypeControl]="true">
                    <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
                    <agm-circle [latitude]="lat" [longitude]="lng" [(radius)]="geofence" [fillColor]="'orange'"
                        [circleDraggable]="true" [editable]="true" (radiusChange)="radiusChanged($event)">
                    </agm-circle>
                  </agm-map>
                </div>
                <div class="col-md-12">
                  <button type="button" (click)="saveLocation()" class="btn btn-success btn-round">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
